export type PmisData = {
    packagedDangerousGoodsBoarding?: PackagedDangerousGoodsData<BoardingPackagedDangerousGood>,
    packagedDangerousGoodsUnboarding?: PackagedDangerousGoodsData<UnboardingPackagedDangerousGood>,
    packagedDangerousGoodsBoardingFromTranship?: PackagedDangerousGoodsData<BoardingFromTranshipmentPackagedDangerousGood>,
    packagedDangerousGoodsUnboardingToTranship?: PackagedDangerousGoodsData<UnboardingToTranshipmentPackagedDangerousGood>,
    packagedDangerousGoodsTransit?: PackagedDangerousGoodsData<TransitPackagedDangerousGood>,
}

export type PackagedDangerousGoodsData<T extends PackagedDangerousGoods> = {
    header: string,
    packagedDangerousGoodsList: {
        packagedDangerousGoods: Array<T>
    }
}

//pattern value ([A-Z]|[0-9]){0,11}
export type PmisContainerType = string;

export enum PmisUMPackagedDangerousGoods {
    Kg = "KG",
    Tons = "TONS",
    Liter = "LITER",
    CubicMter = "CUBIC_METER"
}

export type PmisShipInfoExpType = string;

export enum MovType {
    Boarding = 1,
    Unboarding = 2,
    Transit = 3,
    TranshipmentBoarding = 4,
    TranshipmentUnboarding = 5
}

export type PackagedDangerousGoods = {
    //Matricola container
    containerReg?: PmisContainerType,
    //Codice ISO container
    isoContainerCode?: string,
    //Codice Internazionale del porto di provenienza
    provenancePort?: string,
    //Codice Internazionale del porto di destinazione
    destinationPort?: string,
    //Targa trailer o chiatta
    trailerPlate?: string,
    //Nome o matricola trailer o chiatta
    trailerName?: string,
    //Numero UN
    unNumber?: number,
    //Classe impostata dall'utente
    goodsClass?: string,
    //Nome tecnico
    technicalName?: string,
    //Rischi
    subsidiaryRisks?: string,
    //Gruppo di imballaggio
    packingGroup?: string,
    //Punto di infiammabilita
    flashPoint?: string,
    //Indicatore di quantita limitata
    limitedQuantity?: boolean,
    //Inquinante marino
    marinePollutant?: boolean,
    //Contenitore vuoto
    empty?: boolean,
    //EQ
    exceptedQuantity?: boolean,
    //Recupero
    salvage?: boolean,
    //Rifiuti
    waste?: boolean,
    //Caldo
    hot?: boolean,
    //Campione
    sample?: boolean,
    //Numero colli
    packagesNumber?: number,
    //Tipo imballo
    packageTypeCode?: string,
    //Check imballo speciale
    specialPacking?: boolean,
    //Tipo imballo speciale
    specialPackingType?: string,
    //Peso netto
    netWeight?: number,
    //Peso lordo
    grossWeight?: number,
    //Unita di misura del peso
    um: PmisUMPackagedDangerousGoods,
    //Propieta del container
    containerProperties?: string,
    //Contatto di emergenza
    emergencyContact?: string,
    //Volume
    volume?: number
}

export type BoardingPackagedDangerousGood = PackagedDangerousGoods & {
    //Posizione a bordo
    destPosition?: string,
}

export type UnboardingPackagedDangerousGood = PackagedDangerousGoods & {
    //Posizione a bordo
    sourcePosition?: string,
}

//export type UnboardingToTranshipmentPackagedDangerousGood = BoardingPackagedDangerousGood & UnboardingPackagedDangerousGood & ({
//    //Tipo di movimento 1=imbarco; 2=sbarco; 3=transito; 4=imbarco da trasbordo; 5=sbarco da trasbordo
//    movType: MovType.Boarding | MovType.Unboarding | MovType.Transit
//} | {
//    //Tipo di movimento 1=imbarco; 2=sbarco; 3=transito; 4=imbarco da trasbordo; 5=sbarco da trasbordo
//    movType: MovType.TranshipmentBoarding | MovType.TranshipmentUnboarding,
//    //Nave di provenienza/destinazione (solo se movType = 4 o 5)
//    extraShip?: PmisShipInfoExpType,
//    //Posizione a bordo sulla nave di provenienza/destinazione (solo se movType = 4 o 5)
//    extraShipPosition?: string,
//})

type TranshipmentPackagedDangerousGoodExtraData = {
    //Nave di provenienza/destinazione (solo se movType = 4 o 5)
    extraShip?: PmisShipInfoExpType,
    //Posizione a bordo sulla nave di provenienza/destinazione (solo se movType = 4 o 5)
    extraShipPosition?: string,
}

export type TransitPackagedDangerousGood = UnboardingPackagedDangerousGood & BoardingPackagedDangerousGood

export type UnboardingToTranshipmentPackagedDangerousGood = UnboardingPackagedDangerousGood & TranshipmentPackagedDangerousGoodExtraData & {
    //Tipo di movimento 1=imbarco; 2=sbarco; 3=transito; 4=imbarco da trasbordo; 5=sbarco da trasbordo
    movType?: MovType.TranshipmentUnboarding,
}
export type BoardingFromTranshipmentPackagedDangerousGood = BoardingPackagedDangerousGood & TranshipmentPackagedDangerousGoodExtraData & {
    //Tipo di movimento 1=imbarco; 2=sbarco; 3=transito; 4=imbarco da trasbordo; 5=sbarco da trasbordo
    movType?: MovType.TranshipmentBoarding,
}